import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _Array$from from "@babel/runtime-corejs3/core-js-stable/array/from";
import _Symbol from "@babel/runtime-corejs3/core-js-stable/symbol";
import _getIteratorMethod from "@babel/runtime-corejs3/core-js/get-iterator-method";
import _typeof from "@babel/runtime-corejs3/helpers/typeof";
import _extends from "@babel/runtime-corejs3/helpers/extends";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof _Symbol !== "undefined" && _getIteratorMethod(o) || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { var _context; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = _sliceInstanceProperty(_context = Object.prototype.toString.call(o)).call(_context, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _Set from "@babel/runtime-corejs3/core-js-stable/set";
import _Object$is from "@babel/runtime-corejs3/core-js-stable/object/is";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import { asyncScheduler, BehaviorSubject, defer, fromEvent, Subscription } from 'rxjs';
import { map, throttleTime } from 'rxjs/operators';
import ResizeObserver from 'resize-observer-polyfill';
import * as styledComponents from 'styled-components';
import mergeCellProps from '../utils/mergeCellProps';
import { browserType } from '../utils';
/** styled-components 类库的版本，ali-react-table 同时支持 v3 和 v5 */

export var STYLED_VERSION = styledComponents.createGlobalStyle != null ? 'v5' : 'v3';
export var STYLED_REF_PROP = STYLED_VERSION === 'v3' ? 'innerRef' : 'ref';
export var OVERSCAN_SIZE = 100;
export var AUTO_VIRTUAL_THRESHOLD = 100;
export function sum(arr) {
  var result = 0;
  arr.forEach(function (x) {
    result += x;
  });
  return result;
} // 使用 defer 避免过早引用 window，导致在 SSR 场景下报错

export var throttledWindowResize$ = defer(function () {
  return fromEvent(window, 'resize', {
    passive: true
  }).pipe(throttleTime(150, asyncScheduler, {
    leading: true,
    trailing: true
  }));
});
export var addResizeObserver = function addResizeObserver(element, handler) {
  var measure = function measure(entries) {
    if (!entries[0] || !entries[0].contentRect) {
      return;
    }

    var contentRect = entries[0].contentRect;
    var hide = contentRect.width === 0 && contentRect.height === 0; // 隐藏条件：高宽都为0

    var rect = _extends({
      hide: hide
    }, contentRect);

    handler && handler(rect);
  };

  var resizeObserver = new ResizeObserver(measure);
  resizeObserver && resizeObserver.observe(element);
  return resizeObserver;
};
/** 获取默认的滚动条大小 */

function getScrollbarSizeImpl() {
  var scrollDiv = document.createElement('div');
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.width = '100px';
  scrollDiv.style.height = '100px';
  scrollDiv.style.overflow = 'scroll';
  scrollDiv.style.top = '-9999px';
  document.body.appendChild(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  var scrollbarHeight = scrollDiv.offsetHeight - scrollDiv.clientHeight;
  document.body.removeChild(scrollDiv);
  return {
    width: scrollbarWidth,
    height: scrollbarHeight
  };
}

var scrollBarSize$;
export function getScrollbarSize() {
  if (scrollBarSize$ == null) {
    scrollBarSize$ = new BehaviorSubject(getScrollbarSizeImpl());
    throttledWindowResize$.pipe(map(function () {
      return getScrollbarSizeImpl();
    })).subscribe(scrollBarSize$);
  }

  return scrollBarSize$.value;
}
/** 同步多个元素之间的 scrollLeft, 每当 scrollLeft 发生变化时 callback 会被调用 */

export function syncScrollLeft(elements, callback) {
  var bypassSet = new _Set();

  function publishScrollLeft(origin, scrollLeft) {
    bypassSet.clear();

    var _iterator = _createForOfIteratorHelper(elements),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var elem = _step.value;

        if (elem === origin) {
          continue;
        }

        elem.scrollLeft = scrollLeft;
        bypassSet.add(elem);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  var subscription = new Subscription();

  var _iterator2 = _createForOfIteratorHelper(elements),
      _step2;

  try {
    var _loop = function _loop() {
      var ele = _step2.value;

      var listener = function listener() {
        if (bypassSet.has(ele)) {
          bypassSet.delete(ele);
          return;
        }

        var scrollLeft = ele.scrollLeft;
        publishScrollLeft(ele, scrollLeft);
        callback(scrollLeft);
      };

      ele.addEventListener('scroll', listener, {
        passive: true
      });
      subscription.add(function () {
        return ele.removeEventListener('scroll', listener);
      });
    };

    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return subscription;
}
/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */

export function shallowEqual(objA, objB) {
  var hasOwnProperty = Object.prototype.hasOwnProperty;

  if (_Object$is(objA, objB)) {
    return true;
  }

  if (_typeof(objA) !== 'object' || objA === null || _typeof(objB) !== 'object' || objB === null) {
    return false;
  }

  var keysA = _Object$keys(objA);

  var keysB = _Object$keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  } // Test for A's keys different from B.


  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !_Object$is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
} // todo: 抽出mergeRowProps

export function composeRowPropsGetter(getRowProps, pendingRowProps) {
  var keys = _Object$keys(pendingRowProps);

  if (keys.length) {
    return function (row, rowIndex) {
      return mergeCellProps(getRowProps(row, rowIndex), pendingRowProps);
    };
  }

  return getRowProps;
}
export function getTableScrollHeaderDOM(domHelper) {
  return browserType.isIE ? domHelper.tableHeaderMain : domHelper.tableHeader;
}
export function getTableScrollFooterDOM(domHelper) {
  return browserType.isIE ? domHelper.tableFooterMain : domHelper.tableFooter;
}